import { Component, Input, OnInit, forwardRef, Inject, AfterViewInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { LoadingService } from '../../services/loading.service';
import { PopupService } from '../../services/popup.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../../environments/environment';

declare var cordova: any;

@Component({
  selector: 'app-bulletin-viewer',
  templateUrl: './bulletin-viewer.component.html',
  styleUrls: ['./bulletin-viewer.component.scss'],
})
export class BulletinViewerComponent implements OnInit, AfterViewInit {


  @Input() bulletinId: string;
  @Input() entityId: string;
  @Input() url: string;
  @Input() title: string;
  @Input() isVideo: Boolean = false
  @Input() isTemplate: Boolean = false;
  @Input() isCustom: Boolean = false;
  @Input() description: string = '';
  @Input() isAcknowledgmentRequired: Boolean = false
  @Input() skill = ""

  @Input() onBulletinAcknowledgmentSuccess : (bulletinId: string) => {}

  acknowedgment: Boolean = false

  constructor(@Inject(forwardRef(() => PopupService)) private popupService ,
    private modalController: ModalController, private userService: UserService
    ,private loadingService: LoadingService, private platform: Platform) { }

  ngOnInit() { 
   
  }

  ngAfterViewInit() {
    // Set up link interception for custom bulletins after view is initialized
    if (this.isCustom) {
      setTimeout(() => {
        this.setupLinkInterceptor();
      }, 100);
    }
  }

  setupLinkInterceptor() {
    const richTextContent = document.querySelector('.rich-text-content');
    if (!richTextContent) {
      return;
    }

    const links = richTextContent.querySelectorAll('a');
    console.log('Found links:', links.length);
    
    links.forEach((link: HTMLAnchorElement) => {
      // Debug: log what we're getting
      console.log('Link href attribute:', link.getAttribute('href'));
      console.log('Link href property:', link.href);
      console.log('Link text content:', link.textContent);
      console.log('Link outerHTML:', link.outerHTML);
      
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        // Try to extract clean URL - check link.href property first as browser parses it
        let href = link.href;
        
        // If href is file:// or contains current location, it's relative - use attribute instead
        if (href.startsWith('file://') || href.includes(window.location.hostname)) {
          href = link.getAttribute('href') || '';
        }
        
        // Clean up the URL
        href = href.trim();
        
        // Remove any quotes or special characters
        href = href.replace(/^["'\s]+|["'\s]+$/g, '');
        
        // If still not a valid URL, try text content
        if (!href.match(/^https?:\/\//i)) {
          const textContent = link.textContent?.trim() || '';
          if (textContent.match(/^https?:\/\//i)) {
            href = textContent.replace(/^["'\s]+|["'\s]+$/g, '');
          }
        }
        
        console.log('Final cleaned href:', href);
        
        if (href && href.match(/^https?:\/\//i)) {
          this.openExternalLink(href);
        } else {
          console.warn('Could not extract valid URL from link');
        }
      }, true);
    });
  }

  openExternalLink(url: string) {
    if (this.platform.is('cordova') && typeof cordova !== 'undefined') {
      // Use cordova.exec to open in external browser
      cordova.exec(
        null, 
        null, 
        'InAppBrowser', 
        'open', 
        [url, '_system', 'location=yes']
      );
    } else {
      // Web fallback
      window.open(url, '_blank');
    }
  }

  closeModal() {
    this.modalController.dismiss()
  }

  async acknowledgeDocument() {

    const loading = await this.loadingService.showLoading().toPromise();

    try {

      await this.userService.acknowledgeBulletin(this.entityId, this.bulletinId, this.skill)
      this.popupService.showModal(
        {
          heading: 'Success!',
          message: 'Bulletin has been acknowledge successfully',
          btn: 'Dismiss',
          navigateRoute: null,
          imgURL: 'assets/images/thumbs-up.png'
        })

      this.modalController.dismiss();

      if(this.onBulletinAcknowledgmentSuccess){
        this.onBulletinAcknowledgmentSuccess(this.bulletinId)
      }

    } catch (e) {
      this.popupService.showModal(
        {
          heading: 'Error',
          message: 'Something went wrong, Please try again later',
          btn: 'Dismiss',
          navigateRoute: null,
          imgURL: 'assets/images/profile.png'
        })
    }
    finally {
      this.loadingService.hideLoading(loading);
    }
  }

}
